import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { ImportCustomerFooterProps } from "models/propTypes/customerPropTypes";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { WizardFormFooter } from "components/common";
import { Portal } from "@mui/material";
//#endregion

const ImportCustomerFooter: React.FC<ImportCustomerFooterProps> = ({
  submitForm,
  wizardProps,
  onFormSubmitSuccess,
}) => {
  const footerMount = document.getElementById(HTMLConstants.EntityCreationLayoutFooterPortalId);

  return (
    <Portal container={footerMount}>
      <WizardFormFooter
        actions={[
          {
            text: TranslationKeys.Customer.ImportCustomers,
            type: StyleEnums.DisplayType.Success,
            successMessage: TranslationKeys.Customer.CustomerImportSuccess,
            onClick: submitForm,
            onActionSuccess: onFormSubmitSuccess,
          },
        ]}
        wizardProps={wizardProps}
      />
    </Portal>
  );
};

export default ImportCustomerFooter;
